export default "__VITE_ASSET__BotEUFma__"